import colors from './colors'
import fonts from './fonts'
import images from './images'
import regexes from './regexes'
import sizes from './sizes'
import xhr from './xhr'

export default {
    colors: colors,
    sizes: sizes,
    xhr: xhr,
    regexes: regexes,
    fonts: fonts,
    images: images
}